import axiosPost from "../axiosPost";

export const migraTipoDePasoGet = async (
    { migraTipoDePasoId = null } = {},
    credentials
) => {
    const body = {
        service: "MigraTipoDePasoGet",
        params: {
            merchantId: credentials.merchantId,
            migraTipoDePasoId,
        },
    };

    return await axiosPost(body, credentials);
};
